import { RefObject, useState } from 'react';
import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface FilterProps {
  onSearchSubmit: (e: any) => void;
  formSearchRef: RefObject<HTMLFormElement>;
}
interface FormSearchValueProps {
  showFlg: '0' | '1' | '2';
}
function Filter({ onSearchSubmit, formSearchRef }: FilterProps) {
  const { t } = useTranslation();

  //ref

  //source
  const SHOW_STATUS_SOURCE: { [key: string]: string } = {
    '0': t('videoFunction.filter.show_valid'),
    '1': t('videoFunction.filter.show_all'),
    '2': t('videoFunction.filter.show_deleted'),
  };
  const SEARCH_SHOW_DELETE_KEY_DEFAULT = '0';
  //state
  const [formSearchValue, setFormSearchValue] = useState<FormSearchValueProps>({
    showFlg: '1',
  });
  function handleCollapsedFormSearch() {
    if (formSearchRef.current) {
      setFormSearchValue({
        ...formSearchValue,
        showFlg: formSearchRef.current['show_flg'].value.trim(),
      });
    }
  }

  return (
    <>
      <form ref={formSearchRef} className="mb-3" onSubmit={onSearchSubmit}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>{t('videoFunction.filter.title')}</Accordion.Header>
            <Accordion.Body onExited={handleCollapsedFormSearch}>
              <Row>
                <Col sm={3}>
                  <Row>
                    <Col sm={10} className="">
                      <Form.Label className="col-form-label">{t('videoFunction.filter.title_selection')}：</Form.Label>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col className="" sm={20}>
                      <div className="" style={{ marginLeft: 60 }}>
                        {Object.keys(SHOW_STATUS_SOURCE).map(function (key) {
                          return (
                            <Form.Check
                              key={`show-status-${key}`}
                              className="col-form-label1 form-label1 py-1"
                              type="radio"
                              name="show_flg"
                              id={`show-status-${key}`}
                              value={key}
                              defaultChecked={key === SEARCH_SHOW_DELETE_KEY_DEFAULT}
                              label={SHOW_STATUS_SOURCE[key]}
                            />
                          );
                        })}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Button type="submit">{t('videoFunction.filter.narrow_down')}</Button>
                </Col>
              </Row>
            </Accordion.Body>
            <div className="accordion-body accordion-summary">
              <Row>
                <Col sm={'auto'}>
                  <Form.Label className="col-form-label">{t('videoFunction.filter.title_selection')}：</Form.Label>
                  <Form.Label className="col-form-label">
                    {SHOW_STATUS_SOURCE[formSearchValue.showFlg] || '-'}
                  </Form.Label>
                </Col>
              </Row>
            </div>
          </Accordion.Item>
        </Accordion>
      </form>
    </>
  );
}

export default Filter;
